'use client';

import { cx } from '../utils/cx';

export interface LoadingDotsProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<LoadingDotsProps['size']>, string> = {
  sm: 'h-1.5 w-1.5',
  md: 'h-2 w-2',
  lg: 'h-3 w-3',
};

/**
 * Three animated dots indicating an active (streaming) response.
 * Used in the coach chat streaming preview.
 */
export function LoadingDots({ size = 'sm', className }: LoadingDotsProps) {
  const dotSize = SIZE_CLASS[size];

  return (
    <span
      className={cx('inline-flex items-center gap-1', className)}
      aria-label="Loading"
      aria-live="polite"
      role="status"
    >
      <span
        aria-hidden="true"
        className={cx(dotSize, 'rounded-full bg-brand')}
        style={{ animation: 'blink 1.2s infinite 0s' }}
      />
      <span
        aria-hidden="true"
        className={cx(dotSize, 'rounded-full bg-brand')}
        style={{ animation: 'blink 1.2s infinite 0.18s' }}
      />
      <span
        aria-hidden="true"
        className={cx(dotSize, 'rounded-full bg-brand')}
        style={{ animation: 'blink 1.2s infinite 0.36s' }}
      />
      <style>{`
        @keyframes blink {
          0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
          40% { opacity: 1; transform: translateY(-2px); }
        }
      `}</style>
    </span>
  );
}

LoadingDots.displayName = 'LoadingDots';